export const regFormHandleMemberCount = (flag, count = null) => {
  if (count) {
    return {
      type: "SET_EXPLICIT_COUNT_REGISTER_FORM",
      payload: count
    }
  } else {
    return {
      type: flag
        ? "INCREMENT_MEMBER_COUNT_REGISTER_FORM"
        : "DECREMENT_MEMBER_COUNT_REGISTER_FORM"
    }
  }
}
